import { render, staticRenderFns } from "./AreaManagersPageDetails.vue?vue&type=template&id=32bbe3d0&"
import script from "./AreaManagersPageDetails.vue?vue&type=script&lang=ts&"
export * from "./AreaManagersPageDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32bbe3d0')) {
      api.createRecord('32bbe3d0', component.options)
    } else {
      api.reload('32bbe3d0', component.options)
    }
    module.hot.accept("./AreaManagersPageDetails.vue?vue&type=template&id=32bbe3d0&", function () {
      api.rerender('32bbe3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/AreaManagers/AreaManagersPageDetails.vue"
export default component.exports